import { Wrench } from "lucide-react";

interface Props {
  toolName: string;
  args: Record<string, unknown>;
}

export function ToolCallBlock({ toolName, args }: Props) {
  return (
    <details className="my-2 rounded-md border bg-card p-2 text-xs">
      <summary className="flex cursor-pointer items-center gap-1 font-medium">
        <Wrench className="h-3 w-3 text-muted-foreground" />
        <span>
          Chamou tool: <code className="font-mono">{toolName}</code>
        </span>
      </summary>
      <pre className="mt-2 max-h-60 overflow-auto whitespace-pre-wrap rounded bg-muted/30 p-2 font-mono">
        {JSON.stringify(args, null, 2)}
      </pre>
    </details>
  );
}
